(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const track = root.querySelector('[data-mf-track]');
    const cards = Array.from(root.querySelectorAll('[data-mf-card]'));
    const modelButtons = Array.from(root.querySelectorAll('[data-mf-model]'));
    const seriesButtons = Array.from(root.querySelectorAll('[data-mf-series-filter]'));
    const mobileSeries = root.querySelector('[data-mf-mobile-series]');
    const progress = root.querySelector('[data-mf-progress]');
    const progressFill = progress?.querySelector('[data-mf-progress-fill]');
    const progressLabel = progress?.querySelector('[data-mf-progress-label]');
    const progressFormat = progress?.dataset.progressFormat || '';
    const visibleCards = () => cards.filter((card) => !card.hidden);
    const updateProgress = () => {
      const visible = visibleCards();
      if (!visible.length || !progress) {
        if (progress) progress.hidden = true;
        return;
      }
      progress.hidden = false;
      const currentLeft = track?.scrollLeft || 0;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;
      visible.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - (track?.offsetLeft || 0) - currentLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });
      const current = nearestIndex + 1;
      const total = visible.length;
      if (progressFill) progressFill.style.width = `${(current / total) * 100}%`;
      if (progressLabel) progressLabel.textContent = progressFormat
        .replaceAll('__current__', String(current))
        .replaceAll('__total__', String(total))
        .replace(/\{\s*current\s*\}/g, String(current))
        .replace(/\{\s*total\s*\}/g, String(total));
    };
    const sizeStep = () => {
      const card = cards.find((item) => !item.hidden) || cards[0];
      return card ? card.getBoundingClientRect().width + 18 : (track?.clientWidth || 0) * 0.85;
    };

    root.querySelector('[data-mf-prev]')?.addEventListener('click', () => track?.scrollBy({ left: -sizeStep(), behavior: 'smooth' }));
    root.querySelector('[data-mf-next]')?.addEventListener('click', () => track?.scrollBy({ left: sizeStep(), behavior: 'smooth' }));

    const setSeries = (series) => {
      cards.forEach((card) => { card.hidden = series !== 'all' && card.dataset.series !== series; });
      seriesButtons.forEach((button) => {
        const selected = button.dataset.mfSeriesFilter === series;
        button.setAttribute('aria-pressed', String(selected));
        button.classList.toggle('is-selected', selected);
      });
      if (mobileSeries && mobileSeries.value !== series) mobileSeries.value = series;
      const firstVisible = cards.find((card) => !card.hidden);
      if (firstVisible && track) track.scrollTo({ left: firstVisible.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      root.querySelector('.kk-moebel-finder__more[open]')?.removeAttribute('open');
      window.requestAnimationFrame(updateProgress);
    };
    seriesButtons.forEach((button) => button.addEventListener('click', () => setSeries(button.dataset.mfSeriesFilter || 'all')));
    mobileSeries?.addEventListener('change', () => setSeries(mobileSeries.value || 'all'));

    const selectedBar = root.querySelector('[data-mf-selected]');
    const selectedName = root.querySelector('[data-mf-selected-name]');
    const selectedImage = root.querySelector('[data-mf-selected-image]');
    const panels = Array.from(root.querySelectorAll('[data-mf-panel]'));
    const changeButton = root.querySelector('[data-mf-change]');
    const previewFull = root.querySelector('[data-mf-preview-full]');
    const nextStepNote = root.querySelector('.kk-moebel-finder__next-note');
    const isFull = root.dataset.mode === 'full';
    const requestPanel = root.querySelector('[data-mf-request-panel]');
    const requestSelection = requestPanel?.querySelector('[data-mf-request-selection]');
    const requestBody = requestPanel?.querySelector('[data-mf-contact-body]');
    let lastRequestTrigger = null;
    const requestSkuRules = new Map([
      ['storklinta-3-schubladen:dark_grey', ['WIC123-81', 'WIC123-82', 'WIC123-83']],
      ['storklinta-4-schubladen:dark_grey', ['WIC123-81', 'WIC123-82', 'WIC123-83']],
      ['storklinta-6-schubladen:white', ['WIC123-84']],
      ['storklinta-6-schubladen:dark_grey', ['WIC123-86']]
    ]);
    const requestStorageKey = `kk-mf-request:${root.id}`;
    const requestSkusFor = (model, color) => {
      if (!model || !color || color.dataset.productUrl) return [];
      const key = `${model.dataset.handle}:${color.dataset.colorKey}`;
      const expected = requestSkuRules.get(key) || [];
      const actual = (color.dataset.notifySkus || '').split(',').map((sku) => sku.trim()).filter(Boolean);
      return expected.length && expected.length === actual.length && expected.every((sku) => actual.includes(sku))
        ? expected
        : [];
    };
    const requestValue = (selector, value) => {
      const input = requestPanel?.querySelector(selector);
      if (input) input.value = value || '';
    };
    const requestModelFor = (trigger) => {
      const card = trigger.closest('[data-mf-card]');
      return card?.querySelector('[data-mf-model][aria-pressed="true"]')
        || modelButtons.find((button) => button.getAttribute('aria-pressed') === 'true')
        || null;
    };
    const requestSelectionBody = (model, color) => {
      const modelName = model?.dataset.name || '';
      const colorName = color?.dataset.colorLabel || '';
      const sku = requestSkusFor(model, color).join(', ');
      const format = requestPanel?.dataset.requestBodyFormat || '';
      const unknownSku = requestPanel?.dataset.requestSkuUnknown || '';
      return format.replaceAll('__model__', modelName).replaceAll('__color__', colorName).replaceAll('__sku__', sku || unknownSku);
    };
    const showRequestPanel = (trigger) => {
      const model = requestModelFor(trigger);
      if (!model || !modelButtons.includes(model)) return;
      const card = model.closest('[data-mf-card]');
      const swatch = activeColorFor(card, model.dataset.handle);
      const colorGroup = colorGroupFor(card, model.dataset.handle);
      if (colorGroup && !colorGroup.contains(swatch)) return;
      const knownSwatches = Array.from(colorGroup?.querySelectorAll('[data-mf-color]') || []);
      if (swatch && !knownSwatches.includes(swatch)) return;
      const skus = requestSkusFor(model, swatch);
      if (!skus.length) return;
      const body = requestSelectionBody(model, swatch);
      const sku = skus.join(', ');
      try {
        sessionStorage.setItem(requestStorageKey, JSON.stringify({
          modelHandle: model.dataset.handle,
          colorKey: swatch.dataset.colorKey
        }));
      } catch {}
      if (requestSelection) requestSelection.textContent = body;
      requestValue('[data-mf-contact-model]', model.dataset.name);
      requestValue('[data-mf-contact-model-handle]', model.dataset.handle);
      requestValue('[data-mf-contact-color]', swatch?.dataset.colorLabel || '');
      requestValue('[data-mf-contact-color-key]', swatch?.dataset.colorKey || '');
      requestValue('[data-mf-contact-sku]', sku);
      if (requestBody) requestBody.value = body;
      if (requestPanel) {
        requestPanel.hidden = false;
        requestPanel.scrollIntoView({ block: 'start', behavior: 'smooth' });
        requestPanel.querySelector('input[type="email"]')?.focus({ preventScroll: true });
      }
    };
    requestPanel?.querySelector('[data-mf-request-close]')?.addEventListener('click', () => {
      requestPanel.hidden = true;
      if (lastRequestTrigger && !lastRequestTrigger.hidden && lastRequestTrigger.getClientRects().length) lastRequestTrigger.focus();
    });
    root.querySelectorAll('[data-mf-request-open]').forEach((button) => {
      button.addEventListener('click', () => {
        lastRequestTrigger = button;
        showRequestPanel(button);
      });
    });

    const setFurnitureImage = (card, imageUrl, alt) => {
      const image = card?.querySelector('[data-mf-main-image]');
      const missing = card?.querySelector('[data-mf-no-image]');
      if (!image) return;
      if (imageUrl) {
        image.src = imageUrl;
        image.removeAttribute('srcset');
        image.alt = alt || '';
        image.hidden = false;
        if (missing) missing.hidden = true;
      } else {
        image.removeAttribute('src');
        image.removeAttribute('srcset');
        image.alt = '';
        image.hidden = true;
        if (missing) missing.hidden = false;
      }
    };

    const colorGroupFor = (card, handle) => Array.from(card?.querySelectorAll('[data-mf-color-group]') || [])
      .find((group) => group.dataset.modelHandle === handle);
    const activeColorFor = (card, handle) => colorGroupFor(card, handle)
      ?.querySelector('[data-mf-color][aria-pressed="true"]') || null;
    const selectionHref = (button, colorButton) => {
      const url = new URL(button.dataset.url || window.location.href, window.location.href);
      url.searchParams.set('moebel', button.dataset.handle);
      if (colorButton?.dataset.colorKey) url.searchParams.set('farbe', colorButton.dataset.colorKey);
      else url.searchParams.delete('farbe');
      return `${url.pathname}${url.search}${url.hash}`;
    };
    const setModelCta = (button, colorButton, visible) => {
      const card = button?.closest('[data-mf-card]');
      const cta = card?.querySelector('[data-mf-cta]');
      const colorGroup = colorGroupFor(card, button?.dataset.handle);
      const requiresColor = Boolean(colorGroup?.querySelector('[data-mf-color]'));
      if (!cta) return;
      const storklinta = button?.dataset.handle?.startsWith('storklinta-');
      const productUrl = colorButton?.dataset.productUrl || button?.dataset.uniqueProductUrl;
      const requestButton = card?.querySelector('[data-mf-request-open]');
      const requestPreview = requestSkusFor(button, colorButton).length > 0;
      if (requestButton) requestButton.hidden = !visible || !requestPreview;
      if (button?.dataset.previewOnly === 'true' || !button?.dataset.url || (requiresColor && !colorButton)) {
        cta.hidden = true;
        return;
      }
      if (storklinta || productUrl) {
        const previewNote = card?.querySelector('[data-mf-preview-note]');
        cta.hidden = !visible || !productUrl;
        if (previewNote) previewNote.hidden = Boolean(productUrl) || !visible;
        if (productUrl) {
          cta.href = productUrl;
          if (cta.dataset.productLabel) cta.textContent = cta.dataset.productLabel;
        }
        return;
      }
      const previewNote = card?.querySelector('[data-mf-preview-note]');
      if (previewNote) previewNote.hidden = true;
      cta.href = selectionHref(button, colorButton);
      if (cta.dataset.attachmentLabel) cta.textContent = cta.dataset.attachmentLabel;
      cta.hidden = !visible;
    };
    const updateSelectionUrl = (button, colorButton) => {
      const url = new URL(window.location.href);
      url.searchParams.set('moebel', button.dataset.handle);
      if (colorButton?.dataset.colorKey) url.searchParams.set('farbe', colorButton.dataset.colorKey);
      else url.searchParams.delete('farbe');
      window.history.replaceState({}, '', url);
    };
    const setSelectedSummary = (button, colorButton) => {
      const label = [button?.dataset.name, colorButton?.dataset.colorLabel].filter(Boolean).join(' · ');
      if (selectedName) selectedName.textContent = label;
      const imageUrl = colorButton?.dataset.image || button?.dataset.image || '';
      if (selectedImage && imageUrl) {
        selectedImage.src = imageUrl;
        selectedImage.alt = label;
        selectedImage.hidden = false;
      } else if (selectedImage) {
        selectedImage.removeAttribute('src');
        selectedImage.alt = '';
        selectedImage.hidden = true;
      }
    };
    const applyColor = (card, colorButton) => {
      if (!card || !colorButton) return;
      const group = colorButton.closest('[data-mf-color-group]');
      const modelButton = modelButtons.find((item) => item.dataset.handle === group?.dataset.modelHandle);
      group?.querySelectorAll('[data-mf-color]').forEach((item) => {
        item.setAttribute('aria-pressed', String(item === colorButton));
      });
      card.dataset.selectedColor = colorButton.dataset.colorKey || '';
      const colorName = colorButton.dataset.colorLabel || '';
      setFurnitureImage(card, colorButton.dataset.image, [modelButton?.dataset.name, colorName].filter(Boolean).join(' · '));
      const label = group?.querySelector('[data-mf-color-label]');
      const format = group?.dataset.colorFormat || '';
      if (label) {
        label.textContent = format.replace('__color__', colorName);
        label.hidden = false;
      }
      const pickerOpen = !isFull || !root.classList.contains('has-selection');
      setModelCta(modelButton, colorButton, pickerOpen);
      if (isFull && root.classList.contains('has-selection') && modelButton?.getAttribute('aria-pressed') === 'true') {
        setSelectedSummary(modelButton, colorButton);
      }
    };

    root.querySelectorAll('[data-mf-color]').forEach((button) => {
      button.addEventListener('click', () => applyColor(button.closest('[data-mf-card]'), button));
    });

    const clearFullSelection = () => {
      modelButtons.forEach((button) => {
        button.setAttribute('aria-pressed', 'false');
        button.classList.remove('is-selected');
      });
      cards.forEach((card) => {
        card.dataset.selectedColor = '';
        card.querySelectorAll('[data-mf-color-group]').forEach((group) => {
          group.hidden = true;
          group.querySelectorAll('[data-mf-color]').forEach((swatch) => swatch.setAttribute('aria-pressed', 'false'));
        });
        const cta = card.querySelector('[data-mf-cta]');
        const note = card.querySelector('[data-mf-preview-note]');
        if (cta) cta.hidden = true;
        card.querySelectorAll('[data-mf-request-open]').forEach((button) => { button.hidden = true; });
        const previewFamily = Array.from(card.querySelectorAll('[data-mf-model]')).length > 0
          && Array.from(card.querySelectorAll('[data-mf-model]')).every((button) => button.dataset.previewOnly === 'true');
        if (note) note.hidden = !previewFamily;
      });
      panels.forEach((panel) => { panel.hidden = true; });
      if (previewFull) previewFull.hidden = true;
      if (nextStepNote) nextStepNote.hidden = false;
      requestPanel?.setAttribute('hidden', '');
      if (selectedBar) selectedBar.hidden = true;
      if (selectedName) selectedName.textContent = '';
      if (selectedImage) {
        selectedImage.removeAttribute('src');
        selectedImage.alt = '';
        selectedImage.hidden = true;
      }
      root.classList.remove('has-selection', 'is-changing');
    };

    const selectModel = (button, options = {}) => {
      if (!button) return;
      const {
        updateUrl = true,
        commit = !isFull,
        requestedColorKey
      } = options;
      const handle = button.dataset.handle;
      const familyCard = button.closest('[data-mf-card]');
      const modelName = button.dataset.name || '';
      const previewOnly = button.dataset.previewOnly === 'true';
      const rememberedColor = familyCard?.dataset.selectedColor || '';
      (isFull ? modelButtons : Array.from(familyCard?.querySelectorAll('[data-mf-model]') || [])).forEach((item) => {
        const selected = item === button;
        item.setAttribute('aria-pressed', String(selected));
        item.classList.toggle('is-selected', selected);
      });
      const groups = Array.from((isFull ? root : familyCard)?.querySelectorAll('[data-mf-color-group]') || []);
      groups.forEach((group) => { group.hidden = group.closest('[data-mf-card]') !== familyCard || group.dataset.modelHandle !== handle; });
      const activeColorGroup = colorGroupFor(familyCard, handle);
      const swatches = Array.from(activeColorGroup?.querySelectorAll('[data-mf-color]') || []);
      const hasRequestedColor = Object.prototype.hasOwnProperty.call(options, 'requestedColorKey');
      const activeSwatch = hasRequestedColor
        ? swatches.find((item) => item.dataset.colorKey === requestedColorKey)
        : swatches.find((item) => item.dataset.colorKey === rememberedColor)
          || swatches.find((item) => item.getAttribute('aria-pressed') === 'true')
          || swatches[0];
      activeColorGroup?.querySelectorAll('[data-mf-color]').forEach((item) => {
        item.setAttribute('aria-pressed', String(item === activeSwatch));
      });
      if (activeSwatch) applyColor(familyCard, activeSwatch);
      else {
        if (familyCard) familyCard.dataset.selectedColor = '';
        setFurnitureImage(familyCard, button.dataset.image, modelName);
        const colorLabel = activeColorGroup?.querySelector('[data-mf-color-label]');
        if (colorLabel) colorLabel.hidden = true;
      }

      const previewNote = familyCard?.querySelector('[data-mf-preview-note]');
      const storklintaColorPreview = handle.startsWith('storklinta-') && !activeSwatch?.dataset.productUrl;
      const effectivePreview = previewOnly || storklintaColorPreview;
      if (previewNote) previewNote.hidden = !effectivePreview;
      if (nextStepNote) nextStepNote.hidden = effectivePreview;
      const summary = familyCard?.querySelector('[data-mf-model-summary]');
      if (summary) {
        summary.textContent = button.dataset.subtitle || '';
        summary.hidden = !summary.textContent;
      }
      setModelCta(button, activeSwatch, !isFull || !commit);

      if (!isFull) {
        return;
      }
      if (!commit) {
        cards.forEach((card) => {
          const cta = card.querySelector('[data-mf-cta]');
          const note = card.querySelector('[data-mf-preview-note]');
          if (cta && card !== familyCard) cta.hidden = true;
          const previewFamily = Array.from(card.querySelectorAll('[data-mf-model]')).length > 0
            && Array.from(card.querySelectorAll('[data-mf-model]')).every((model) => model.dataset.previewOnly === 'true');
          if (note) note.hidden = card === familyCard ? !effectivePreview : !previewFamily;
        });
        panels.forEach((panel) => { panel.hidden = true; });
        if (previewFull) previewFull.hidden = true;
        if (selectedBar) selectedBar.hidden = true;
        root.classList.remove('has-selection');
        root.classList.add('is-changing');
        return;
      }
      cards.forEach((card) => {
        const cta = card.querySelector('[data-mf-cta]');
        if (cta) cta.hidden = true;
      });
      const activePanel = panels.find((panel) => panel.dataset.handle === handle);
      panels.forEach((panel) => { panel.hidden = panel !== activePanel; });
      if (activePanel) {
        const productCards = Array.from(activePanel.querySelectorAll('[data-mf-product]'));
        const noResults = activePanel.querySelector('[data-mf-no-results]');
        const isStorklinta = handle.startsWith('storklinta-');
        let visibleCount = 0;
        productCards.forEach((productCard) => {
          const matchesColor = !isStorklinta || productCard.dataset.productColor === activeSwatch?.dataset.colorKey;
          productCard.hidden = !matchesColor;
          if (matchesColor) visibleCount += 1;
        });
        const colorPreview = activePanel.querySelector('[data-mf-color-preview]');
        const requestButton = activePanel.querySelector('[data-mf-request-open]');
        if (noResults) noResults.hidden = visibleCount > 0 || (isStorklinta && visibleCount === 0);
        if (colorPreview) colorPreview.hidden = !isStorklinta || visibleCount > 0;
        if (requestButton) requestButton.hidden = requestSkusFor(button, activeSwatch).length === 0 || visibleCount > 0;
        if (nextStepNote && isStorklinta && visibleCount === 0) nextStepNote.hidden = true;
      }
      if (previewFull) previewFull.hidden = !(previewOnly && !activePanel);
      const previewRequestButton = previewFull?.querySelector('[data-mf-request-open]');
      if (previewRequestButton) previewRequestButton.hidden = !(previewOnly && !activePanel && requestSkusFor(button, activeSwatch).length > 0);
      setSelectedSummary(button, activeSwatch);
      if (selectedBar) selectedBar.hidden = false;
      root.classList.add('has-selection');
      root.classList.remove('is-changing');
      const resultHeading = activePanel?.querySelector('[data-mf-result-heading]');
      const target = selectedBar || resultHeading || (previewOnly ? previewFull : null);
      if (target) {
        if (resultHeading) resultHeading.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      if (updateUrl) {
        updateSelectionUrl(button, activeSwatch);
      }
    };

    modelButtons.forEach((button) => button.addEventListener('click', () => {
      const colorGroup = colorGroupFor(button.closest('[data-mf-card]'), button.dataset.handle);
      if (isFull && button.dataset.uniqueProductUrl && !colorGroup?.querySelector('[data-mf-color]')) {
        window.location.assign(button.dataset.uniqueProductUrl);
        return;
      }
      selectModel(button);
    }));
    root.querySelectorAll('[data-mf-card] [data-mf-cta]').forEach((link) => link.addEventListener('click', (event) => {
      if (!isFull) return;
      const card = link.closest('[data-mf-card]');
      const button = card?.querySelector('[data-mf-model][aria-pressed="true"]');
      const colorGroup = colorGroupFor(card, button?.dataset.handle);
      const colorButton = activeColorFor(card, button?.dataset.handle);
      const requiresColor = Boolean(colorGroup?.querySelector('[data-mf-color]'));
      if (!button || button.dataset.previewOnly === 'true' || (requiresColor && !colorButton)) {
        event.preventDefault();
        return;
      }
      if (colorButton?.dataset.productUrl || button.dataset.uniqueProductUrl) return;
      event.preventDefault();
      selectModel(button, { commit: true, updateUrl: true });
    }));
    changeButton?.addEventListener('click', () => {
      root.classList.remove('has-selection');
      root.classList.add('is-changing');
      const firstSelected = modelButtons.find((button) => button.getAttribute('aria-pressed') === 'true') || modelButtons[0];
      if (selectedBar) selectedBar.hidden = true;
      if (firstSelected) setModelCta(firstSelected, activeColorFor(firstSelected.closest('[data-mf-card]'), firstSelected.dataset.handle), true);
      firstSelected?.focus();
      firstSelected?.closest('[data-mf-card]')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });

    const restoreRequestPanel = () => {
      if (!requestPanel?.querySelector('[data-mf-form-success], [role="alert"]')) return;
      let saved = null;
      try {
        saved = JSON.parse(sessionStorage.getItem(requestStorageKey) || 'null');
      } catch (error) {
        saved = null;
      }
      if (saved) {
        const savedModel = modelButtons.find((button) => button.dataset.handle === saved.modelHandle);
        if (savedModel) {
          const savedColor = Array.from(colorGroupFor(savedModel.closest('[data-mf-card]'), savedModel.dataset.handle)?.querySelectorAll('[data-mf-color]') || [])
            .find((swatch) => swatch.dataset.colorKey === saved.colorKey);
          if (savedColor && requestSkusFor(savedModel, savedColor).length) {
            selectModel(savedModel, { updateUrl: false, commit: isFull, requestedColorKey: saved.colorKey });
            const body = requestSelectionBody(savedModel, savedColor);
            const sku = requestSkusFor(savedModel, savedColor).join(', ');
            if (requestSelection) requestSelection.textContent = body;
            requestValue('[data-mf-contact-model]', savedModel.dataset.name);
            requestValue('[data-mf-contact-model-handle]', savedModel.dataset.handle);
            requestValue('[data-mf-contact-color]', savedColor.dataset.colorLabel);
            requestValue('[data-mf-contact-color-key]', savedColor.dataset.colorKey);
            requestValue('[data-mf-contact-sku]', sku);
            if (requestBody) requestBody.value = body;
          }
        }
      }
      requestPanel.hidden = false;
      requestPanel.querySelector('[data-mf-request-heading]')?.focus({ preventScroll: true });
    };

    if (isFull) {
      const params = new URL(window.location.href).searchParams;
      const requested = params.get('moebel');
      const requestedColor = params.get('farbe');
      const match = modelButtons.find((button) => button.dataset.handle === requested);
      if (match && requestedColor) {
        const requestedColorButton = Array.from(colorGroupFor(match.closest('[data-mf-card]'), match.dataset.handle)?.querySelectorAll('[data-mf-color]') || [])
          .find((swatch) => swatch.dataset.colorKey === requestedColor);
        if (requestedColorButton) selectModel(match, { updateUrl: false, commit: true, requestedColorKey: requestedColor, strictColor: true });
        else selectModel(match, { updateUrl: false, commit: false, requestedColorKey: requestedColor, strictColor: true });
      } else if (match) selectModel(match, { updateUrl: false, commit: true });
      else clearFullSelection();
    } else {
      cards.forEach((card) => {
        const selected = card.querySelector('[data-mf-model][aria-pressed="true"]') || card.querySelector('[data-mf-model]');
        if (selected) selectModel(selected, { updateUrl: false, commit: false });
      });
      track?.addEventListener('scroll', () => window.requestAnimationFrame(updateProgress), { passive: true });
      window.addEventListener('resize', () => window.requestAnimationFrame(updateProgress), { passive: true });
      window.requestAnimationFrame(updateProgress);
    }
    restoreRequestPanel();
  };

  const start = () => document.querySelectorAll('[data-kk-mf-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
